import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { PermissionService } from '../../services';
import { PageInfoType } from '../../types';

@Component({
  selector: 'info-view',
  templateUrl: './info-view.component.html',
  styleUrls: ['./info-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoViewComponent extends BaseResizableComponent {
  private readonly permService = inject(PermissionService);

  @Input() data?: PageInfoType | null;
  @Input() loading = false;
  @Output() startEditing = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<string>();

  readonly allowEditing$ = this.permService.allowEditing$;
  readonly allowDeleting$ = this.permService.allowDeleting$;

  onClickEditButton(): void {
    this.startEditing.emit();
  }

  onClickDeleteButton(): void {
    if (!this.data) {
      // TODO: вывести ошибку
      return;
    }

    this.deleted.emit(this.data.id);
  }
}
